import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  FormGroup,
  FormLabel,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { MAX_CAPACITY } from "@shared-constants";
import { Colors } from "@template/style";
import FileItem from "components/molecules/FileItem";
import TemplateSelectBox from "components/molecules/TemplateSelectBox";
import { STORAGE, storeData } from "@utils/Storage";
import styles from "./styles";

interface IProps {
  selectedImages: any;
  selectedFiles: any;
  template: any;
}

interface ISelectImageFileConfirmProps {
  selectedImages: any;
  selectedFiles: any;
}

const SelectFileReportConfirm: React.VFC<IProps> = ({
  selectedImages = [],
  selectedFiles = [],
  template,
}: IProps) => {
  // const [disabledImage, setDisableImage] = useState<boolean | undefined>(false);
  // const [disabledFile, setDisableFile] = useState<boolean>(false);
  // useEffect(() => {
  //   if (selectedFiles.length >= MAX_CAPACITY) {
  //     setDisableFile(true);
  //   } else {
  //     setDisableFile(false);
  //   }
  //   if (selectedImages.length >= MAX_CAPACITY) {
  //     setDisableImage(true);
  //   } else setDisableImage(false);
  // }, [selectedFiles, selectedImages]);

  return (
    <>
      <Card>
        <CardHeader title="内容" sx={styles.header} />
        <CardContent>
          {/* ============= テンプレート ============= */}
          {template ? (
            <TemplateSelectBox
              template={template}
              onClick={() => {
                storeData(STORAGE.PREVIEW_DATA, JSON.stringify(template));
                window.open("/preview");
              }}
              buttonType="confirm"
            />
          ) : null}
        </CardContent>
      </Card>
      <Card>
        <CardHeader title="添付" sx={styles.header} />
        <CardContent>
          <SelectImageFileConfirm
            selectedImages={selectedImages}
            selectedFiles={selectedFiles}
          />
        </CardContent>
      </Card>
    </>
  );
};

// ====================================
// 添付コンポーネント
// ====================================
export const SelectImageFileConfirm: React.VFC<
  ISelectImageFileConfirmProps
> = ({ selectedImages, selectedFiles }: ISelectImageFileConfirmProps) => {
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState("");

  return (
    <Stack>
      {/* =================== 画像 =================== */}
      <FormGroup>
        <FormLabel
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          画像
          <Typography
            sx={{ ml: 1, color: Colors.DISABLE_BTN_TEXT }}
            variant="body2"
          >
            {MAX_CAPACITY}点まで
          </Typography>
        </FormLabel>
        <Grid container spacing={2} my={1}>
          {selectedImages.map((item: any, index: number) => (
            <Grid item xs={4} sm={2} key={index}>
              <Box
                component="img"
                onClick={() => {
                  setOpen(true);
                  setImageSrc(
                    item?.file_type === "image/svg+xml"
                      ? item.path_file_thumb
                      : item.path_file,
                  );
                }}
                src={
                  item?.file_type === "image/svg+xml"
                    ? item.path_file_thumb
                    : item.path_file
                }
                key={item.size}
                sx={{
                  width: "100%",
                  height: { xs: 80, md: 100 },
                  objectFit: "cover",
                  borderRadius: 1,
                  cursor: "pointer",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </FormGroup>
      <Dialog open={open} onClick={() => setOpen(false)}>
        <Box
          component={"img"}
          src={imageSrc}
          sx={{ maxWidth: "100%", maxHeight: "calc(100vh - 64px)" }}
        />
      </Dialog>

      {/* =================== 資料 =================== */}
      <FormGroup>
        <FormLabel
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          資料
          <Typography
            sx={{ ml: 1, color: Colors.DISABLE_BTN_TEXT }}
            variant="body2"
          >
            {MAX_CAPACITY}点まで
          </Typography>
        </FormLabel>
        <FileItem data={selectedFiles} editable={false} />
      </FormGroup>
    </Stack>
  );
};

export default SelectFileReportConfirm;
